export default {
    isSelfServiced: false,
    isENT: false,
    checkoutType: null,
    selectedDiscount: 0,
    currencyIsoCode: null,
    isExistingCustomer: false,
    accountId: null,
    opptyId: null,
    userEmail: null,
    source: null,
    writtenLanguage: null,
    checkoutCompleted: null,
    activePaymentProcessing: false,
    licenseTerm: null,
    smallFleetOpportunity: false,
    firstPurchase: false,
    selectedPaymentType: null,
    paymentMethod: null,
    isDelinquent: false,
    isPmUpdate: false,
    isMicro: false,
    lastFour: null,
    safetyEventReview: false,
    isDeferred: null,
    segment: null,
    isRenewal: null,
    licenseStartDate: null,
    initialPaymentTerm: null,
    approvedPaymentType: null,
    hideLicenses: false,
    hasContractExpired:false,
    creditLimit: null,
    sentPaymentTypeErrorEmail: false,
    contract: {
        endDate: null,
        isContractOnFile: false,
    },
    safetyEventReviewPrice: null,
    renewalTerm: 36,
    isArcadian: false,
    autoRenewalOptOut: false
}
